(function () {
  'use strict';

  const DESKTOP_MQ = '(min-width: 990px)';
  const DESKTOP_SWATCH_PX = 37;
  const MOBILE_SWATCH_PX = 36;
  const getSwatchPx = () => (window.matchMedia(DESKTOP_MQ).matches ? DESKTOP_SWATCH_PX : MOBILE_SWATCH_PX);
  const getSwatchSize = () => `${getSwatchPx()}px`;
  const STYLE_ID = 'nicha-gpo-square-swatch-styles';
  const PIERRES_RE = /pierre/i;
  const TISSUS_RE = /tissu|fabric|textile|mati[eè]re/i;

  let resizeTimer = null;
  let observerStarted = false;

  const isDesktop = () => window.matchMedia(DESKTOP_MQ).matches;

  const getGroupLabel = (group) => {
    const labelEl =
      group.querySelector('.gpo-label .label-content') ||
      group.querySelector('.gpo-label') ||
      group.querySelector('.gpo-title') ||
      group.querySelector('legend');

    return (
      labelEl?.textContent?.trim() ||
      group.getAttribute('data-option-name') ||
      group.getAttribute('data-name') ||
      ''
    ).toLowerCase();
  };

  const getFieldName = (group) => {
    const input = group.querySelector(
      'input[data-field-name], input[data-type="image-swatches"][name], input[type="radio"][name]'
    );
    return (input?.getAttribute('data-field-name') || input?.getAttribute('name') || '').toLowerCase();
  };

  const getGroupType = (group) => {
    const label = getGroupLabel(group);
    if (PIERRES_RE.test(label)) return 'pierres';
    if (TISSUS_RE.test(label)) return 'tissus';

    const fieldName = getFieldName(group);
    if (PIERRES_RE.test(fieldName)) return 'pierres';
    if (TISSUS_RE.test(fieldName)) return 'tissus';
    return null;
  };

  const classifyWrapper = (wrapper, type) => {
    const group = wrapper.closest('.gpo-element, .gpo-group, [class*="gpo-element"]');
    const target = group || wrapper;
    target.classList.remove('nicha-gpo-pierres', 'nicha-gpo-tissus');
    target.removeAttribute('data-nicha-gpo-type');
    if (type === 'pierres') {
      target.classList.add('nicha-gpo-pierres');
      target.setAttribute('data-nicha-gpo-type', 'pierres');
    }
    if (type === 'tissus') {
      target.classList.add('nicha-gpo-tissus');
      target.setAttribute('data-nicha-gpo-type', 'tissus');
    }
  };

  const getWrapperType = (wrapper) => {
    const input = wrapper.querySelector('input[data-field-name], input[data-type="image-swatches"][name]');
    const fieldName = (input?.getAttribute('data-field-name') || input?.getAttribute('name') || '').toLowerCase();
    if (PIERRES_RE.test(fieldName)) return 'pierres';
    if (TISSUS_RE.test(fieldName)) return 'tissus';
    return null;
  };

  const classifyGloboGroups = () => {
    const root = document.querySelector('.product__info-wrapper, .product__info-container');
    if (!root) return;

    const groups = root.querySelectorAll(
      '.globo-product-options .gpo-element, .globo-product-options .gpo-group, [data-globo-product-options] .gpo-element, [data-globo-product-options] .gpo-group, .globo-product-options > div[class*="gpo"]'
    );

    groups.forEach((group) => {
      const type = getGroupType(group);

      group.classList.remove('nicha-gpo-pierres', 'nicha-gpo-tissus');
      group.removeAttribute('data-nicha-gpo-type');

      if (type === 'pierres') {
        group.classList.add('nicha-gpo-pierres');
        group.setAttribute('data-nicha-gpo-type', 'pierres');
      }
      if (type === 'tissus') {
        group.classList.add('nicha-gpo-tissus');
        group.setAttribute('data-nicha-gpo-type', 'tissus');
      }
    });

    root.querySelectorAll('.gpo-ov-wrapper').forEach((wrapper) => {
      const type = getWrapperType(wrapper);
      if (type) classifyWrapper(wrapper, type);
    });
  };

  const injectSquareStyles = () => {
    let style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }

    style.textContent = `
      @media (min-width: 990px) {
        .product__info-wrapper [data-nicha-gpo-type="pierres"] .gpo-ov-wrapper,
        .product__info-wrapper .gpo-ov-wrapper:has(input[name*="Pierre"]),
        .product__info-wrapper .gpo-ov-wrapper:has(input[data-field-name*="Pierre"]),
        .product__info-wrapper [data-nicha-gpo-type="tissus"] .gpo-ov-wrapper,
        .product__info-wrapper .gpo-ov-wrapper:has(input[name="Tissu"]),
        .product__info-wrapper .gpo-ov-wrapper:has(input[data-field-name="Tissu"]) {
          --nicha-swatch-size: ${DESKTOP_SWATCH_PX}px;
        }
        .product__info-wrapper [data-nicha-gpo-type="pierres"] .gpo-ov-wrapper,
        .product__info-wrapper .gpo-ov-wrapper:has(input[name*="Pierre"]),
        .product__info-wrapper .gpo-ov-wrapper:has(input[data-field-name*="Pierre"]) {
          display: flex !important;
          flex-direction: row !important;
          flex-wrap: nowrap !important;
          overflow: visible !important;
          gap: 4px !important;
          align-items: flex-start !important;
          width: 100% !important;
        }
        .product__info-wrapper [data-nicha-gpo-type="tissus"] .gpo-ov-wrapper,
        .product__info-wrapper .gpo-ov-wrapper:has(input[name="Tissu"]),
        .product__info-wrapper .gpo-ov-wrapper:has(input[data-field-name="Tissu"]) {
          display: flex !important;
          flex-direction: row !important;
          flex-wrap: wrap !important;
          align-items: flex-start !important;
          align-content: flex-start !important;
          justify-content: flex-start !important;
          overflow: visible !important;
          gap: 4px !important;
          width: 100% !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
        }
        .product__info-wrapper [data-nicha-gpo-type="tissus"] .gpo-ov-wrapper > :not(.gpo-ov-item):not(.image-swatches),
        .product__info-wrapper .gpo-ov-wrapper:has(input[name="Tissu"]) > :not(.gpo-ov-item):not(.image-swatches) {
          flex: 0 0 100% !important;
          width: 100% !important;
          display: block !important;
          order: 999 !important;
          margin-top: 2px !important;
        }
        .product__info-wrapper [data-nicha-gpo-type="pierres"] .gpo-ov-wrapper .gpo-ov-item,
        .product__info-wrapper .gpo-ov-wrapper:has(input[name*="Pierre"]) .gpo-ov-item,
        .product__info-wrapper .gpo-ov-wrapper:has(input[data-field-name*="Pierre"]) .gpo-ov-item,
        .product__info-wrapper [data-nicha-gpo-type="tissus"] .gpo-ov-wrapper .gpo-ov-item,
        .product__info-wrapper .gpo-ov-wrapper:has(input[name="Tissu"]) .gpo-ov-item,
        .product__info-wrapper .gpo-ov-wrapper:has(input[data-field-name="Tissu"]) .gpo-ov-item {
          width: ${DESKTOP_SWATCH_PX}px !important;
          height: ${DESKTOP_SWATCH_PX}px !important;
          min-width: ${DESKTOP_SWATCH_PX}px !important;
          min-height: ${DESKTOP_SWATCH_PX}px !important;
          max-width: ${DESKTOP_SWATCH_PX}px !important;
          max-height: ${DESKTOP_SWATCH_PX}px !important;
          flex: 0 0 ${DESKTOP_SWATCH_PX}px !important;
          display: block !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: visible !important;
          position: relative !important;
        }
        .product__info-wrapper [data-nicha-gpo-type="pierres"] .gpo-ov-item > .gpo-ov-extend,
        .product__info-wrapper [data-nicha-gpo-type="tissus"] .gpo-ov-item > .gpo-ov-extend,
        .product__info-wrapper .gpo-ov-wrapper:has(input[name="Tissu"]) .gpo-ov-item > .gpo-ov-extend,
        .product__info-wrapper .gpo-ov-wrapper:has(input[name*="Pierre"]) .gpo-ov-item > .gpo-ov-extend {
          display: none !important;
          height: 0 !important;
          overflow: hidden !important;
        }
        .product__info-wrapper [data-nicha-gpo-type="pierres"] [data-nicha-square-swatch],
        .product__info-wrapper [data-nicha-gpo-type="tissus"] [data-nicha-square-swatch],
        .product__info-wrapper [data-nicha-square-swatch] {
          width: 100% !important;
          height: 100% !important;
          min-width: 0 !important;
          min-height: 0 !important;
          max-width: none !important;
          max-height: none !important;
          aspect-ratio: 1 / 1 !important;
          padding: 0 !important;
          margin: 0 !important;
          overflow: visible !important;
          box-sizing: border-box !important;
          line-height: 0 !important;
          font-size: 0 !important;
          display: block !important;
          position: relative !important;
        }
        .product__info-wrapper [data-nicha-square-swatch] .gpo-swatch__inner {
          width: 100% !important;
          height: 100% !important;
          display: block !important;
          overflow: hidden !important;
          line-height: 0 !important;
          font-size: 0 !important;
        }
        .product__info-wrapper [data-nicha-square-swatch] img,
        .product__info-wrapper [data-nicha-square-swatch] .gpo-swatch-image,
        .product__info-wrapper [data-nicha-square-swatch] [class*="swatch-image"] {
          width: 100% !important;
          height: 100% !important;
          min-width: 0 !important;
          min-height: 0 !important;
          max-width: none !important;
          max-height: none !important;
          display: block !important;
          object-fit: cover !important;
          margin: 0 !important;
          padding: 0 !important;
          aspect-ratio: 1 / 1 !important;
        }
      }
    `;
  };

  const clearSizeProps = (el) => {
    ['width', 'height', 'min-width', 'min-height', 'max-width', 'max-height', 'flex-basis', 'aspect-ratio'].forEach(
      (prop) => el.style.removeProperty(prop)
    );
  };

  const fixTissusStockLayout = (area) => {
    if (!area) return;

    area.querySelectorAll(':scope > :not(.gpo-ov-item):not(.image-swatches)').forEach((el) => {
      el.style.setProperty('flex', '0 0 100%', 'important');
      el.style.setProperty('order', '999', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('max-width', '100%', 'important');
      el.style.setProperty('display', 'block', 'important');
      el.style.removeProperty('height');
    });

    const group = area.closest('.gpo-element, .nicha-gpo-tissus');
    if (!group) return;

    group.querySelectorAll(':scope > :not(.gpo-label):not(.gpo-ov-wrapper)').forEach((el) => {
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('max-width', '100%', 'important');
      el.style.setProperty('margin-top', '0.35rem', 'important');
      el.style.setProperty('clear', 'both', 'important');
    });
  };

  const markOvItem = (item, type) => {
    if (!item) return;
    const size = getSwatchSize();
    item.style.setProperty('width', size, 'important');
    item.style.setProperty('height', size, 'important');
    item.style.setProperty('min-width', size, 'important');
    item.style.setProperty('min-height', size, 'important');
    item.style.setProperty('max-width', size, 'important');
    item.style.setProperty('max-height', size, 'important');
    item.style.setProperty('flex', `0 0 ${size}`, 'important');
    item.style.setProperty('display', 'block', 'important');
    item.style.setProperty('overflow', 'visible', 'important');
    item.style.setProperty('position', 'relative', 'important');

    const extend = item.querySelector(':scope > .gpo-ov-extend');
    if (extend && !extend.textContent.trim()) {
      extend.style.setProperty('display', 'none', 'important');
      extend.style.setProperty('height', '0', 'important');
    }
  };

  const markSquareSwatch = (el) => {
    if (!el || el.nodeType !== 1) return;
    if (el.classList.contains('gpo-switch')) return;
    if (el.classList.contains('gpo-label')) return;
    if (el.matches('.gpo-ov-item, .image-swatches')) return;

    clearSizeProps(el);
    el.setAttribute('data-nicha-square-swatch', 'true');
    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('height', '100%', 'important');
    el.style.setProperty('min-width', '0', 'important');
    el.style.setProperty('min-height', '0', 'important');
    el.style.setProperty('max-width', 'none', 'important');
    el.style.setProperty('max-height', 'none', 'important');
    el.style.setProperty('aspect-ratio', '1 / 1', 'important');
    el.style.setProperty('padding', '0', 'important');
    el.style.setProperty('overflow', 'visible', 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
    el.style.setProperty('line-height', '0', 'important');
    el.style.setProperty('font-size', '0', 'important');
    el.style.setProperty('position', 'relative', 'important');
    el.style.setProperty('display', 'block', 'important');

    el.querySelectorAll('.gpo-swatch__inner').forEach((inner) => {
      clearSizeProps(inner);
      inner.style.setProperty('width', '100%', 'important');
      inner.style.setProperty('height', '100%', 'important');
      inner.style.setProperty('overflow', 'hidden', 'important');
      inner.style.setProperty('display', 'block', 'important');
      inner.style.setProperty('line-height', '0', 'important');
      inner.style.setProperty('font-size', '0', 'important');
    });

    el.querySelectorAll('img.swatch-image, .gpo-swatch-image, [class*="swatch-image"]').forEach((inner) => {
      if (inner.closest('.gpo-tooltip')) return;
      clearSizeProps(inner);
      inner.style.removeProperty('position');
      inner.style.removeProperty('inset');
      inner.style.setProperty('width', '100%', 'important');
      inner.style.setProperty('height', '100%', 'important');
      inner.style.setProperty('object-fit', 'cover', 'important');
      inner.style.setProperty('display', 'block', 'important');
      inner.style.setProperty('margin', '0', 'important');
      inner.style.setProperty('padding', '0', 'important');
      inner.style.setProperty('aspect-ratio', '1 / 1', 'important');
    });
  };

  const getSwatchArea = (group) =>
    group.querySelector('.gpo-ov-wrapper') ||
    group.querySelector('[class*="gpo-swatches"]') ||
    group.querySelector('.gpo-checkbox-group');

  const getSwatchElements = (group) => {
    const area = getSwatchArea(group);
    if (!area) return [];

    const found = new Set();

    area.querySelectorAll('label[for^="image-swatches"]').forEach((el) => found.add(el));

    if (!found.size) {
      area.querySelectorAll('.gpo-swatches label, .gpo-ov-item label').forEach((el) => {
        if (!el.classList.contains('gpo-label') && el.querySelector('img.swatch-image, img, [class*="swatch-image"]')) {
          found.add(el);
        }
      });
    }

    if (!found.size) {
      area.querySelectorAll('button[class*="swatch"], label[class*="swatch"]').forEach((el) => {
        if (!el.classList.contains('gpo-label')) found.add(el);
      });

      area.querySelectorAll('button, label').forEach((el) => {
        if (el.classList.contains('gpo-label')) return;
        if (el.closest('.gpo-label')) return;
        if (el.querySelector('img, .gpo-swatch-image, [class*="swatch-image"], [style*="background"]')) {
          found.add(el);
        }
      });
    }

    return [...found];
  };

  const enforceLayoutOnArea = (area, type) => {
    if (!area || !type) return;

    area.style.setProperty('--nicha-swatch-size', getSwatchSize());

    if (type === 'pierres') {
      area.style.setProperty('display', 'flex', 'important');
      area.style.setProperty('flex-direction', 'row', 'important');
      area.style.setProperty('flex-wrap', 'nowrap', 'important');
      area.style.setProperty('overflow', 'visible', 'important');
      area.style.setProperty('align-items', 'flex-start', 'important');
      area.style.setProperty('gap', '4px', 'important');
      area.style.setProperty('width', '100%', 'important');
    }

    if (type === 'tissus') {
      area.style.setProperty('display', 'flex', 'important');
      area.style.setProperty('flex-direction', 'row', 'important');
      area.style.setProperty('flex-wrap', 'wrap', 'important');
      area.style.setProperty('align-items', 'flex-start', 'important');
      area.style.setProperty('align-content', 'flex-start', 'important');
      area.style.setProperty('justify-content', 'flex-start', 'important');
      area.style.setProperty('overflow', 'visible', 'important');
      area.style.removeProperty('max-height');
      area.style.removeProperty('grid-template-rows');
      area.style.removeProperty('grid-auto-flow');
      area.style.removeProperty('grid-auto-columns');
      area.style.setProperty('gap', '4px', 'important');
      area.style.setProperty('width', '100%', 'important');
      area.style.setProperty('max-width', '100%', 'important');
      area.style.setProperty('box-sizing', 'border-box', 'important');
      fixTissusStockLayout(area);
    }

    area.querySelectorAll('.gpo-ov-item, .image-swatches.gpo-ov-item').forEach((item) => {
      item.style.removeProperty('grid-template-rows');
      item.style.removeProperty('grid-auto-flow');
      markOvItem(item, type);
      const label = item.querySelector('label[for^="image-swatches"]');
      if (label) markSquareSwatch(label);
    });
  };

  const enforceSquareSwatchesInGroup = (group) => {
    const type = getGroupType(group);
    if (type !== 'pierres' && type !== 'tissus') return;

    const area = getSwatchArea(group);
    if (!area) return;

    enforceLayoutOnArea(area, type);
    getSwatchElements(group).forEach(markSquareSwatch);
  };

  const enforceSquareSwatches = () => {
    if (!isDesktop()) return;

    injectSquareStyles();

    const root = document.querySelector('.product__info-wrapper');
    if (!root) return;

    const processed = new Set();

    root.querySelectorAll('.gpo-ov-wrapper').forEach((wrapper) => {
      const type = getWrapperType(wrapper);
      if (type !== 'pierres' && type !== 'tissus') return;
      classifyWrapper(wrapper, type);
      enforceLayoutOnArea(wrapper, type);
      processed.add(wrapper);
    });

    root
      .querySelectorAll(
        '.globo-product-options .gpo-element, .globo-product-options .gpo-group, [data-globo-product-options] .gpo-element'
      )
      .forEach((group) => {
        const type = getGroupType(group);
        if (type !== 'pierres' && type !== 'tissus') return;
        const area = getSwatchArea(group);
        if (area && processed.has(area)) return;
        enforceSquareSwatchesInGroup(group);
      });
  };

  const refresh = () => {
    if (!isDesktop()) return;
    classifyGloboGroups();
    enforceSquareSwatches();
  };

  const watch = () => {
    if (observerStarted || typeof MutationObserver === 'undefined') return;
    const container = document.querySelector('.product__info-container');
    if (!container) return;

    observerStarted = true;
    let debounce;
    new MutationObserver(() => {
      clearTimeout(debounce);
      debounce = setTimeout(refresh, 200);
    }).observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  };

  const init = () => {
    if (!document.querySelector('.product__info-container')) return;
    refresh();
    watch();
  };

  const boot = () => {
    init();
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refresh, 200);
    });
    document.addEventListener('shopify:section:load', () => {
      observerStarted = false;
      setTimeout(init, 200);
    });
    [200, 500, 1000, 2000, 4000, 7000, 10000].forEach((d) => setTimeout(refresh, d));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.NichaProductFormCompact = { refresh };
})();
